module.exports = __webpack_public_path__ + "static/img/qq1.c78779f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qq1.png
// module id = tSau
// module chunks = 0